import { defineComponent as R, ref as c, computed as k, watch as S, openBlock as u, createElementBlock as g, withKeys as T, normalizeClass as v, unref as r, createCommentVNode as N, createBlock as w, Fragment as j, renderList as J, toDisplayString as B } from "vue";
import { DArrowLeft as Q, MoreFilled as K, DArrowRight as U } from "./index537.js";
import { paginationPagerProps as W } from "./index750.js";
import { CHANGE_EVENT as q } from "./index584.js";
import { useNamespace as D } from "./index559.js";
import { useLocale as X } from "./index597.js";
const Y = ["aria-current", "aria-label", "tabindex"], Z = ["tabindex", "aria-label"], _ = ["aria-current", "aria-label", "tabindex"], ee = ["tabindex", "aria-label"], ae = ["aria-current", "aria-label", "tabindex"];
var ie = /* @__PURE__ */ R({
  name: "ElPaginationPager",
  __name: "pager",
  props: W,
  emits: [q],
  setup(H, { emit: V }) {
    const n = H, L = V, f = D("pager"), $ = D("icon"), { t: p } = X(), h = c(!1), E = c(!1), b = c(!1), m = c(!1), y = c(!1), M = c(!1), z = k(() => {
      const e = n.pagerCount, a = (e - 1) / 2, t = Number(n.currentPage), l = Number(n.pageCount);
      let s = !1, i = !1;
      l > e && (t > e - a && (s = !0), t < l - a && (i = !0));
      const C = [];
      if (s && !i) {
        const o = l - (e - 2);
        for (let d = o; d < l; d++)
          C.push(d);
      } else if (!s && i)
        for (let o = 2; o < e; o++)
          C.push(o);
      else if (s && i) {
        const o = Math.floor(e / 2) - 1;
        for (let d = t - o; d <= t + o; d++)
          C.push(d);
      } else
        for (let o = 2; o < l; o++)
          C.push(o);
      return C;
    }), G = k(() => [
      "more",
      "btn-quickprev",
      $.b(),
      f.is("disabled", n.disabled)
    ]), I = k(() => [
      "more",
      "btn-quicknext",
      $.b(),
      f.is("disabled", n.disabled)
    ]), P = k(() => n.disabled ? -1 : 0);
    S(
      () => [n.pageCount, n.pagerCount, n.currentPage],
      ([e, a, t]) => {
        const l = (a - 1) / 2;
        let s = !1, i = !1;
        e > a && (s = t > a - l, i = t < e - l), b.value && (b.value = s), m.value && (m.value = i), h.value = s, E.value = i;
      },
      { immediate: !0 }
    );
    function F(e = !1) {
      n.disabled || (e ? b.value = !0 : m.value = !0);
    }
    function x(e = !1) {
      e ? y.value = !0 : M.value = !0;
    }
    function O(e) {
      const a = e.target;
      if (a.tagName.toLowerCase() === "li" && Array.from(a.classList).includes("number")) {
        const t = Number(a.textContent);
        t !== n.currentPage && L(q, t);
      } else a.tagName.toLowerCase() === "li" && Array.from(a.classList).includes("more") && A(e);
    }
    function A(e) {
      const a = e.target;
      if (a.tagName.toLowerCase() === "ul" || n.disabled)
        return;
      let t = Number(a.textContent);
      const l = n.pageCount, s = n.currentPage, i = n.pagerCount - 2;
      a.className.includes("more") && (a.className.includes("quickprev") ? t = s - i : a.className.includes("quicknext") && (t = s + i)), Number.isNaN(+t) || (t < 1 && (t = 1), t > l && (t = l)), t !== s && L(q, t);
    }
    return (e, a) => (u(), g(
      "ul",
      {
        class: v(r(f).b()),
        onClick: A,
        onKeyup: T(O, ["enter"])
      },
      [
        e.pageCount > 0 ? (u(), g("li", {
          key: 0,
          class: v([[
            r(f).is("active", e.currentPage === 1),
            r(f).is("disabled", e.disabled)
          ], "number"]),
          "aria-current": e.currentPage === 1,
          "aria-label": r(p)("el.pagination.currentPage", { pager: 1 }),
          tabindex: P.value
        }, " 1 ", 10, Y)) : N("v-if", !0),
        h.value ? (u(), g("li", {
          key: 1,
          class: v(G.value),
          tabindex: P.value,
          "aria-label": r(p)("el.pagination.prevPages", { pager: e.pagerCount - 2 }),
          onMouseenter: a[0] || (a[0] = (t) => F(!0)),
          onMouseleave: a[1] || (a[1] = (t) => b.value = !1),
          onFocus: a[2] || (a[2] = (t) => x(!0)),
          onBlur: a[3] || (a[3] = (t) => y.value = !1)
        }, [
          (b.value || y.value) && !e.disabled ? (u(), w(r(Q), { key: 0 })) : (u(), w(r(K), { key: 1 }))
        ], 42, Z)) : N("v-if", !0),
        (u(!0), g(
          j,
          null,
          J(z.value, (t) => (u(), g("li", {
            key: t,
            class: v([[
              r(f).is("active", e.currentPage === t),
              r(f).is("disabled", e.disabled)
            ], "number"]),
            "aria-current": e.currentPage === t,
            "aria-label": r(p)("el.pagination.currentPage", { pager: t }),
            tabindex: P.value
          }, B(t), 11, _))),
          128
          /* KEYED_FRAGMENT */
        )),
        E.value ? (u(), g("li", {
          key: 2,
          class: v(I.value),
          tabindex: P.value,
          "aria-label": r(p)("el.pagination.nextPages", { pager: e.pagerCount - 2 }),
          onMouseenter: a[4] || (a[4] = (t) => F()),
          onMouseleave: a[5] || (a[5] = (t) => m.value = !1),
          onFocus: a[6] || (a[6] = (t) => x()),
          onBlur: a[7] || (a[7] = (t) => M.value = !1)
        }, [
          (m.value || M.value) && !e.disabled ? (u(), w(r(U), { key: 0 })) : (u(), w(r(K), { key: 1 }))
        ], 42, ee)) : N("v-if", !0),
        e.pageCount > 1 ? (u(), g("li", {
          key: 3,
          class: v([[
            r(f).is("active", e.currentPage === e.pageCount),
            r(f).is("disabled", e.disabled)
          ], "number"]),
          "aria-current": e.currentPage === e.pageCount,
          "aria-label": r(p)("el.pagination.currentPage", { pager: e.pageCount }),
          tabindex: P.value
        }, B(e.pageCount), 11, ae)) : N("v-if", !0)
      ],
      34
      /* CLASS, NEED_HYDRATION */
    ));
  }
});
export {
  ie as default
};
